import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import reducer_product from './reducer/reducer-product'
import reducer_cart from './reducer/reducer-cart'
import reducer_order from './reducer/reducer-order'
import reducer_user from './reducer/reducer-user'
import reducer_ALL from './reducer/reducer-ALL'


const initialState = {

};


const reducers = combineReducers({
    reducer_product,
    reducer_cart,
    reducer_order,
    reducer_user,
    reducer_ALL,

})

const composeEnhancer = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;


const store = createStore(
    reducers,
    initialState,
    composeEnhancer(applyMiddleware(thunk))
);


export default store;